import Crud from '../views/Uf/Crud'
import Entity from '../views/Uf/Add'

let routes = {
    path: '/ufs',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/ufs/add',
            name: 'NewUf',
            component: Entity
        },
        {
            path: '/ufs/edit/:id?',
            name: 'EditUf',
            component: Entity
        },
        {
            path: '/ufs',
            name: 'list-ufs',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Ufs',
                breadcrumb: [
                    {
                        text: 'Ufs',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
